import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserMasterModel } from './user-master.model';
import { UserModel } from '../../models/complex/user.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-core-user-master',
    templateUrl: './user-master.component.html',
    styleUrls: ['./user-master.component.scss'],
})
export class UserMasterComponent {
    @Input()
    public model: UserMasterModel;

    @Output()
    public selectedUserModel = new EventEmitter<UserModel>();
    public constructor(private readonly modalInstance: BsModalRef) {}

    public setSalesOrgAndPlant(userInfo: UserModel): void {
        this.selectedUserModel.emit(userInfo);
        this.selectedUserModel.complete();
        this.modalInstance.hide();
    }
}
